<!-- 控销-商品管理 -->
<template>
  <div class="classification">
    <div class="header">
      <el-form ref="formTool" :model="formTool" :inline="true" style="text-align: left">
        <el-form-item prop="nameLike" label="">
          <el-input v-model.trim="formTool.nameLike" placeholder="请输入海报名称" clearable size="small" />
        </el-form-item>

        <el-form-item prop="extendType" label="类别">
          <el-select v-model="formTool.extendType" clearable style="width: 120px;" size="small" placeholder="类别">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="getList(1)">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small" @click="reset()">重置</el-button>
        </el-form-item>

      </el-form>
      <el-button size="small" type="primary" @click="detailHandle({}, 'add')">新增</el-button>
    </div>

    <div class="center" style="position: relative">
      <MyTable :table-data="tableData" :index="index" :selection="selection" :page="page" :operation="operation"
        :table-option.sync="tableOption" @page-change="getList" @handleSelectionChange="handleSelectionChange">
        <template slot="extendType" slot-scope="scope">
          <span v-if="scope.row.extendType == 'SALESMAN'"> 业务员</span>
          <span v-if="scope.row.extendType == 'CLIENT'"> 客户</span>
        </template>

        <template slot="image" slot-scope="scope">
          <el-row>
            <el-col style="width:80px">
              <el-image :src="scope.row.extendPlacard
                ? scope.row.extendPlacard
                : avater
                " lazy style="width: 80px; height: 80px" />
            </el-col>
          </el-row>
        </template>

        <template slot="menu" slot-scope="scope" style="width: 300px;">
          <div class="btn-warp">
            <el-link :underline="false" type="primary" @click="detailHandle(scope.row, 'edit')"
              class="btn-list">编辑</el-link>
            <el-link :underline="false" type="primary" @click="detailHandle(scope.row, 'delet')"
              class="btn-list">删除</el-link>
          </div>
        </template>

        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]" layout="sizes, prev, pager, next" :total="page.total">
        </el-pagination>

      </MyTable>
    </div>

    <addDialog ref="add-dialog" @getList="getList" />
  </div>
</template>

<script>
import MyTable from "@/components/myTable";
import addDialog from "./components/add.vue";
import { mapGetters } from 'vuex'

import { getSalesExtend, salesExtendDelete, } from "@/api/externalSalesRule";

import avater from "/public/img/default.png";
export default {
  components: { MyTable, addDialog },
  data() {
    return {
      avater: avater,
      formTool: {
        name: "",
      },
      btnType: 'add',
      selectionList: [],
      operation: true,
      selection: false,
      index: true,
      tableData: [],
      tableOption: [
        { label: "海报名称", prop: "posterName" },
        { label: "海报图片", prop: "image", slot: true }, // 这里表示自定义列
        { label: "发圈文案", prop: "copywriting" },
        { label: "分享次数", prop: "shareFrequency" },
        { label: "类别", prop: "extendType", slot: true },
        { label: "排序", prop: "sort" },
      ],
      page: {
        total: 10,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 30, 50],
      },
      options: [
        {
          value: 'SALESMAN',
          label: '业务员'
        },
        {
          value: 'CLIENT',
          label: '客户'
        },
      ],
      dialogShow: false
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getSalesExtend();
  },
  mounted() { },
  beforeCreate() { },
  beforeMount() { },
  beforeUpdate() { },
  updated() { },
  beforeDestroy() { },
  destroyed() { },
  activated() { },
  computed: {
    ...mapGetters(['permissions']),
  },
  methods: {
    didSelectItem(row) {
      // 选择商品
      this.$refs['goods-setting-dailog'].init(row, 'add')
    },
    // 页码变化
    handleCurrentChange(e) {
      this.page.current = e
    },
    // 条数变化
    handleSizeChange(e) {
      this.page.size = e
      this.page.current = 1
    },

    detailHandle(row, btnType) {
      if (btnType == 'delet') {
        this.$confirm('确定删除该海报?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.removePromotion(row)
          })
          .catch(() => {

          })
      } else {
        this.$refs['add-dialog'].init(row, btnType)
      }
    },
    //删除海报
    removePromotion(row) {
      salesExtendDelete({ id: row.id }).then((res) => {
        if(res){
          this.getList(1); 
        }
      });
    },
    // 重置查询条件
    reset() {
      this.formTool = {};
      this.getList(1);
    },
    // 搜索
    getList(current) {
      this.getSalesExtend(current);
    },
    // 勾选
    handleSelectionChange(val) {
      this.selectionList = val;
    },
    // 查询产品线
    getSalesExtend(current) {
      if (current) {
        // 搜索条件改变从第一页开始查询
        this.page.current = current;
      }
      if (this.formTool.name == "") {
        delete this.formTool.name;
      }
      const params = {
        ...this.formTool,
        current: this.page.current,
        size: this.page.size,
        status: 0, //查询非删除的
      };
      getSalesExtend(params).then((res) => {
        if (res.records) {
          this.tableData = res.records;
          this.page.total = res.total;
          this.page.total = res.total;
        } else {
          this.tableData = [];
          this.page.total = 0;
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
@import "@/styles/variables.scss";

.classification {
  padding: 0px;

  .header {
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 24px 0px 24px !important;
    border-bottom: 1px solid #f5f5f5;

    .font {
      font-size: 16px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 600;
      text-align: left;
      color: #262626;
    }

    .el-form-item {
      margin: 0px 0px 0px 8px !important;
    }
  }

  background: white;

  .top {
    display: flex;
    padding: 10px 0 10px 0;

    .item {
      display: flex;
      align-items: center;
      margin-right: 20px;

      .label {
        width: 120px;
      }

      .button {
        margin-right: 20px;

        ::v-deep .el-button {
          color: $subMenuActiveText;
          background-color: $butColor;
          border-color: $butColor;

          &:hover {
            color: $subMenuActiveText;
            background-color: $butColor;
            border-color: $butColor;
          }

          &:active {
            color: $subMenuActiveText;
            background: $butColor;
            background-color: $butColor;
            border-color: $butColor;
          }

          &:focus {
            color: $subMenuActiveText;
            background-color: $butColor;
            border-color: $butColor;
          }
        }
      }
    }
  }

  .center {
    margin-top: 16px;
    padding: 0 24px;
    height: calc(100% - 131px);

    .shangjia {
      position: absolute;
      z-index: 2;
      bottom: -45px;
    }
  }

  .btn-warp {
    display: flex;
    justify-content: space-around;

    .el-link {
      // margin: 5px;
    }
  }
}
</style>
